import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { finishLogin } from '../services/sso.service';

/**
 * /login/callback — finalizes the SSO session.
 *
 * On mount:
 *   1. Read ?code=&state= from the URL (the IAM redirect).
 *   2. Call /iam/v4/idp/callback — this sets the session cookie.
 *   3. Redirect to / (or wherever the post-login landing is).
 */
export const LoginCallbackPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false); // guard against React 18/19 double-effect

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    finishLogin(window.location.search)
      .then(() => navigate('/collection', { replace: true }))
      .catch((e) => setError(String(e)));
  }, [navigate]);

  if (error) {
    return (
      <div className="flex flex-col gap-3 text-destructive">
        <div className="text-sm font-semibold">SSO callback failed</div>
        <div className="text-xs">{error}</div>
        <button
          type="button"
          className="rounded bg-primary px-4 py-2 text-primary-foreground text-sm"
          onClick={() => navigate('/login', { replace: true })}
        >
          Back to login
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="text-sm font-normal text-medium-emphasis">Signing you in…</div>
    </div>
  );
};